import posthog from 'posthog-js'
import { config } from './config'
import { Feature } from './features'

function setupPostHog () {
  if (config.POSTHOG_API_KEY) {
    posthog.init(config.POSTHOG_API_KEY, {
      api_host: 'https://us.i.posthog.com',
      defaults: '2026-01-30',
      capture_exceptions: true
    })
  }
}

function isFeatureEnabled (feature: Feature) {
  if (!config.POSTHOG_API_KEY) {
    return true
  }
  return posthog.isFeatureEnabled(feature)
}

export { setupPostHog, isFeatureEnabled }
